import Action from "./Action";
import { MANUFACTURE_TYPES, DEVICE_TYPES } from "../../constants/types";

const columns = (setMutate: (mutate: any) => void) => [
    {
        title: "Name",
        dataIndex: "name",
        key: "name",
        sorter: true,
        filter: true,
        filterBy: {
            type: "text",
        },
    },
    {
        title: "System",
        dataIndex: "system_name",
        key: "system_id",
        sorter: false,
        filter: false,
        filterBy: {
            type: "table",
            table: "systems",
            filters: [],
        },
    },
    {
        title: "Manufacture",
        dataIndex: "manufacture_type",
        key: "manufacture_type",
        sorter: false,
        render: (row: any, record: any) => {
            const manufactureType = MANUFACTURE_TYPES.find(
                (type) => type.value === record.manufacture_type,
            );
            return manufactureType ? manufactureType.label : "Custom";
        },
        filter: true,
        filterBy: {
            type: "options",
            options: [
                { label: "Huawei", value: 1 },
                { label: "GoodWe", value: 2 },
                { label: "DEDDIE", value: 3 },
                { label: "ReMoni", value: 4 },
                { label: "Custom", value: -1 },
            ],
        },
    },
    {
        title: "Created By",
        dataIndex: "created_by",
        key: "email",
        sorter: false,
        filter: true,
        filterBy: {
            type: "table",
            table: "companyUser",
            filters: [],
        },
    },
    {
        title: "Device Type",
        dataIndex: "device_type",
        key: "device_type",
        sorter: false,
        render: (row: any, record: any) => {
            const deviceType = DEVICE_TYPES.find(
                (type) => type.value === record.device_type,
            );
            return deviceType ? deviceType.label : "Unknown";
        },
        filter: true,
        filterBy: {
            type: "options",
            options: [
                { label: "Inverter", value: 10 },
                { label: "Grid Electrical Meter", value: 20 },
                { label: "Electrical Meter", value: 30 },
                { label: "Battery", value: 40 },
                { label: "Load", value: 50 },
                { label: "Sensor", value: 60 },
                { label: "Water Sensor", value: 80 },
                { label: "Unknown", value: -1 },
            ],
        },
    },
    {
        title: "Action",
        dataIndex: "id",
        key: "action",
        render: (_: any, record: any) => {
            return <Action setMutate={setMutate} record={record} />;
        },
    },
];
export default columns;